import { ElementProps } from "@/types/elements"
import cn from "clsx"

const Divider = ({ viewMode }: ElementProps) => {
    return (
        <span className="w-full">
            <hr className={cn(viewMode ? "my-3" : "", "bg-slate-100")} />
        </span>

    )
}
export default Divider;